import classNames from "classnames";
import { type PropsWithChildren, useContext } from "react";
import { sessionStore } from "../../contexts/SessionContext";
import OfflineBanner from "../../pages/OfflineBanner/OfflineBanner";
import * as localStorage from "../../utils/localStorage";
import Header from "../Header/Header";
import MobileNav from "../Header/MobileNav/MobileNav";
import TabTitle, { type Props as TabTitleProps } from "../TabTitle/TabTitle";
import "./RouteWithHeaderWrapper.scss";
import { useBreakpoints } from "@evidenceb/athena-common/helpers/breakpoints";

const RouteWithHeaderWrapper = ({
  children,
  routerClassName,
}: PropsWithChildren & { routerClassName?: string }) => {
  const { isMobile } = useBreakpoints();
  return (
    <div
      style={{
        height: isMobile ? "calc(100% + 70px)" : "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <BaseRouteWithHeaderWrapper>
        <div
          className={classNames("router-with-header-wrapper", routerClassName)}
        >
          {children}
        </div>
      </BaseRouteWithHeaderWrapper>
    </div>
  );
};
export default RouteWithHeaderWrapper;

export const BaseRouteWithHeaderWrapper = ({
  children,
  title,
  ...titleProps
}: PropsWithChildren<Partial<TabTitleProps>>) => {
  const {
    session: {
      flags: { displaySignIn },
    },
  } = useContext(sessionStore);
  const googleClassroom = localStorage.getItem(
    localStorage.Key.GOOGLE_CLASSROOM,
  );
  return (
    <>
      {title && <TabTitle title={title} {...titleProps} />}
      {!displaySignIn && !googleClassroom && <Header />}
      <OfflineBanner />
      {children}
      {!displaySignIn && !googleClassroom && <MobileNav />}
    </>
  );
};
